<filter-item-multiple [label]="'ui.filter_status.label' | translate" icon="pi pi-flag" [selectedValues]="selected" [options]="options" (optionSelected)="handleSelected($event)"></filter-item-multiple>
